import { render, staticRenderFns } from "./profile-banner.vue?vue&type=template&id=e991cb8a&scoped=true"
import script from "./profile-banner.vue?vue&type=script&lang=js"
export * from "./profile-banner.vue?vue&type=script&lang=js"
import style0 from "./profile-banner.vue?vue&type=style&index=0&id=e991cb8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e991cb8a",
  null
  
)

export default component.exports